<!--Loader-->
<div *ngIf="isLoading" class="ui active inverted dimmer">
    <div class="ui loader"></div>
</div>

<!-- Body -->
<form *ngIf="task" #form="ngForm" autocomplete="off">
    <div class="task-details">
        <div class="task-details-content padding-bottom-4">
            <!-- Header, Mark as Complete/Completed, Meatball -->
            <div class="app-grid task-name-and-meatball">
                <!-- task name -->
                <h2 class="columns-7 ui header task-name">{{ task.name }}</h2>

                <!-- mark as complete/completed, meatball -->
                <ng-container *ngIf="!isComplete; else showCompletedTaskState">
                    <div class="columns-5 mark-as-complete-with-meatball">
                        <ui-button
                            type="ghost"
                            class="mark-as-complete-button"
                            (click)="$event.preventDefault(); onToggleTaskComplete()"
                        >
                            <span class="mark-as-complete-label"
                                ><mat-icon svgIcon="check"></mat-icon
                                >{{ 'employees.task-details.markAsComplete' | appTranslate }}</span
                            >
                        </ui-button>

                        <!-- Meatball -->
                        <ng-container *ngIf="isAdmin">
                            <ui-button
                                [matMenu]="matMenu"
                                class="meatball tab-menu margin-left-1 margin-top-1"
                                size="no-padding"
                            >
                                <mat-icon svgIcon="meatballHorizontal"></mat-icon>
                            </ui-button>

                            <mat-menu #matMenu xPosition="before">
                                <button mat-menu-item (click)="sendReminder()">
                                    {{ 'employees.task-details.sendReminder' | appTranslate }}
                                </button>
                                <button mat-menu-item (click)="onEdit()">
                                    {{ 'employees.task-details.edit' | appTranslate }}
                                </button>
                                <button *ngIf="task.taskTemplateId" mat-menu-item (click)="onViewTemplate()">
                                    {{ 'employees.task-details.viewTemplate' | appTranslate }}
                                </button>
                            </mat-menu>
                        </ng-container>
                    </div>
                </ng-container>

                <!-- Show Completed button -->
                <ng-template #showCompletedTaskState>
                    <div class="columns-5 completed-button-with-meatball">
                        <ui-button
                            type="primary"
                            class="mark-as-complete-button"
                            (click)="$event.preventDefault(); onToggleTaskComplete()"
                        >
                            <span
                                ><mat-icon svgIcon="check"></mat-icon
                                >{{ 'employees.task-details.completed' | appTranslate }}</span
                            >
                        </ui-button>

                        <!-- Meatball -->
                        <ng-container *ngIf="isAdmin">
                            <ui-button
                                [matMenu]="matMenu"
                                class="meatball tab-menu margin-left-1 margin-top-1"
                                size="no-padding"
                            >
                                <mat-icon svgIcon="meatballHorizontal"></mat-icon>
                            </ui-button>
                            <mat-menu #matMenu xPosition="before">
                                <button mat-menu-item (click)="onEdit()">
                                    {{ 'employees.task-details.edit' | appTranslate }}
                                </button>
                                <button *ngIf="task.taskTemplateId" mat-menu-item (click)="onViewTemplate()">
                                    {{ 'employees.task-details.viewTemplate' | appTranslate }}
                                </button>
                            </mat-menu>
                        </ng-container>
                    </div>
                </ng-template>
            </div>

            <!-- Created For -->
            <div class="app-grid">
                <span class="columns-4 margin-bottom-2 created-for"
                    >{{
                        'employees.task-details.forTasksubjectfullName'
                            | translate: { fullName: task.subject?.fullName }
                    }}
                </span>
            </div>

            <!-- To be Completed by -->
            <div class="app-grid margin-bottom-3">
                <div class="columns-9 assignees">
                    <span class="to-be-completed-by">{{
                        'employees.task-details.toBeCompletedBy' | appTranslate
                    }}</span>

                    <div class="assignee-name padding-left-1">
                        <span *ngIf="task.assigneeType === 'subject'">
                            <app-avatar
                                [showBorder]="true"
                                [employee]="task.assignees[0]"
                                [name]="true"
                                size="font-fixed"
                            ></app-avatar>
                        </span>
                        <span *ngIf="task.assigneeType === 'manager'"
                            ><app-avatar
                                [showBorder]="true"
                                [employee]="task.assignees[0]"
                                [name]="true"
                                size="font-fixed"
                            ></app-avatar>
                        </span>

                        <app-inline-avatars
                            *ngIf="
                                task.assigneeType !== 'subject' &&
                                task.assigneeType !== 'manager' &&
                                task.assignees.length
                            "
                            [numberOfEmployeesToShow]="5"
                            [employees]="task.assignees"
                            size="font-fixed"
                            [showShortNameCopy]="true"
                        >
                        </app-inline-avatars>
                    </div>
                </div>

                <!-- Due date -->
                <div *ngIf="task.dueAt" class="columns-3 due-date padding-top-1">
                    {{ 'employees.task-details.dueTaskdueAt' | translate: { date: task.dueAt | appDate } }}
                </div>
                <div *ngIf="!task.dueAt" class="columns-3 due-date padding-top-1">
                    {{ 'employees.task-details.noDueDate' | appTranslate }}
                </div>
            </div>

            <!-- Description -->
            <div
                *ngIf="task.description"
                class="app-grid margin-top-2 margin-bottom-1"
                [class.removeMarginOnAssignees]="task.assignees.length > 1"
            >
                <div
                    class="columns-12 margin-bottom-2 description"
                    [innerHtml]="task.description | nl2br | sanitizeHtml"
                ></div>
            </div>

            <!-- Hidden elm to add validation for file attachment field -->
            <input
                name="file{{ task.id }}"
                type="hidden"
                [(ngModel)]="task.fileId"
                [required]="task.isAttachmentRequired"
            />

            <!-- File attachment -->
            <div class="app-grid">
                <div class="columns-5 attach-file margin-bottom-1" *ngIf="task.isAttachmentRequired && !task.fileId">
                    <app-file-drop
                        (filesSelected)="onFileSelected($event, task)"
                        [inlineView]="true"
                        [allowedTypes]="allowedFileTypes"
                        [required]="true"
                    ></app-file-drop>
                </div>

                <!-- Error message for file attachment -->
                <mat-error class="attach-file margin-top-1 margin-bottom-1" *ngIf="showFileAttachmentError"
                    >{{ 'employees.task-details.fileAttachmentIsRequired' | appTranslate }}
                </mat-error>

                <!-- File name -->
                <div
                    *ngIf="task.isAttachmentRequired && task.fileId"
                    class="padding-top-1 margin-bottom-1 file-name-with-images"
                >
                    <div
                        class="file cursor"
                        (click)="$event.preventDefault(); $event.stopPropagation(); viewFile(task.file)"
                    >
                        <mat-icon svgIcon="attach" />
                        {{ task.filename }}

                        <ui-button type="link" size="no-padding" (click)="onFileRemoved(task)">
                            <mat-icon svgIcon="close" />
                        </ui-button>
                    </div>
                </div>
            </div>

            <!-- Show progress bar & sub-tasks iff there are sub-tasks -->
            <ng-container *ngIf="task.subtasks.length">
                <!-- Progress bar -->
                <div class="app-grid">
                    <div class="progres-bar">
                        <span class="progress-bar-label">{{
                            'employees.task-details.completedSubtasksCountOfTotalSubtasksCountCompleted'
                                | translate: { completedSubtasksCount, totalSubtasksCount }
                        }}</span>
                        <mat-progress-bar
                            class="columns-12 margin-top-1"
                            mode="determinate"
                            [value]="progressBarValue"
                        ></mat-progress-bar>
                    </div>
                </div>

                <!-- Sub tasks list -->
                <div class="sub-tasks">
                    <ng-container *ngFor="let subtask of task.subtasks">
                        <div class="sub-task-checkbox">
                            <div class="check margin-right-1">
                                <mat-checkbox
                                    [checked]="!!subtask.completedAt"
                                    (click)="onToggleSubTaskComplete(subtask)"
                                ></mat-checkbox>
                            </div>
                            <div
                                class="sub-task-description"
                                (click)="$event.preventDefault(); onToggleSubTaskComplete(subtask)"
                            >
                                <span [class.complete]="!!subtask.completedAt">{{ subtask.description }}</span>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </div>
</form>
